/* eslint-disable */
'use strict'
var dataLayer = window.dataLayer || []

function product(id, name, category, price, quantity) {
  if (category === '') {
    category = 'Outfit'
  }

  return {
    id,
    name,
    category,
    brand: 'The Black Tux',
    price,
    quantity,
  }
}

function genericEcommerce(e, products) {
  var baseObj = {
    event: e,
    ecommerce: {
      currencyCode: 'USD',
    },
  }
  // products can be an array of objects
  // or a single object

  if (products.constructor !== Array) {
    products = [products]
  }

  if (e === 'impressions') {
    for (var i = 0; i < products.length; i++) {
      var aProduct = products[i]
      aProduct.position = aProduct.quantity
      aProduct.list = window.location.pathname.slice(1) // add page location
      delete aProduct.quantity
    }
    baseObj.ecommerce.impressions = {products: products}
    delete baseObj.event
  } else {
    e = e.split(/(?=[A-Z])/)[0]
    baseObj.ecommerce[e] = {products: products}
  }

  return baseObj
}

function onCheckout(products) {
  // at some point an empty array started to get passed into this function
  //  instead of an array filled with products that the user is paying for.
  // the empty array is now hardcoded to make this behavior clear.
  var ecEvent = genericEcommerce('checkout', [])
  dataLayer.push(ecEvent)
}

function addImpression(products) {
  var ecEvent = genericEcommerce('impressions', products)
  dataLayer.push(ecEvent)
}

function onPurchase(actionField, products) {
  var ecEvent = genericEcommerce('purchase', products)
  ecEvent.ecommerce.purchase.actionField = actionField
  dataLayer.push(ecEvent)
}

function onCreatorPurchase(eventSubtotal) {
  window.dataLayer.push({
    event: 'creatorPurchase',
    eventSubtotal: eventSubtotal,
  })
}

function addDetailImpression(products) {
  var ecEvent = genericEcommerce('detailImpressions', products)
  dataLayer.push(ecEvent)
}

/* eslint-enable */

const simple = (event) => () => window.dataLayer.push({event})

export default {
  addDetailImpression,
  addImpression,
  genericEcommerce,
  mobileMenu: {
    opened: simple('mobileMenuOpened'),
    closed: simple('mobileMenuClosed'),
  },
  onCheckout,
  onPurchase,
  onCreatorPurchase,
  product,
  promp: {
    productsGetStarted: simple('prompProductsGetStarted'),
    kickerGetStarted: simple('prompKickerGetStarted'),
  },
}
